import * as Sentry from '@sentry/react';
import { RefreshCcw } from 'lucide-react';
import { useEffect } from 'react';
import { Outlet, useRouteError } from 'react-router';

import { DashboardLayout } from '@/components/layouts/dashboard-layout';
import { Button } from '@/components/ui/button';

export const ErrorBoundary = () => {
  const error = useRouteError() as Error;

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <div className="mx-auto max-w-md space-y-3">
          <h1 className="text-8xl font-semibold">500</h1>
          <h2 className="whitespace-nowrap text-3xl font-medium tracking-tight">
            Oops! Something Went Wrong :(
          </h2>
          <p className="text-pretty text-muted-foreground">
            An unexpected error occurred. Our team is on it. Please refresh or
            try again later. Thanks for your patience!
          </p>
          <Button size="sm" onClick={() => window.location.reload()}>
            <RefreshCcw size={16} /> Reload page
          </Button>
        </div>
      </div>
    </div>
  );
};

const AppRoot = () => {
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
};

export default AppRoot;
